export default __webpack_public_path__ + "static/media/portal_user_resources.6cfb013e.png";